module.exports = __webpack_public_path__ + "static/media/Eagle Face004_3c.15d9e52c.svg";